import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { call } from 'vuex-pathify';
export default {
  name: 'ResetDevice',
  components: {
    FibCommonModal: require("../../components/CommonModal").default
  },
  props: {
    value: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      showConfirmation: false,
      showError: false,
      showSuccess: false,
      showWait: false
    };
  },
  watch: {
    value: function value(activated) {
      this.showConfirmation = activated;
    }
  },
  methods: {
    deregisterDevice: call('config/deregisterDevice'),
    resetAllModuleStates: call('settings/resetAllModuleStates'),
    resetDevice: function resetDevice() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Reset Vuex store and deregister device
                Logger.debug('Reset device');
                _this.showWait = true;
                _context.next = 4;
                return _this.deregisterDevice();

              case 4:
                result = _context.sent;
                _context.next = 7;
                return _this.resetAllModuleStates();

              case 7:
                _this.showWait = false;

                if (result.error) {
                  _this.showError = true;
                } else {
                  _this.showSuccess = true;
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};